import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import { Autocomplete } from "@mui/material";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import AerosDialog from "../AerosDialog";
import useAerosModalStyles from "../../styles/aerosModalStyles";

const FlowBuilderAddSwitchFlowModal = ({ open, onSave, onUpdate, data, close }) => {
  const m = useAerosModalStyles();
  const [activeModal, setActiveModal] = useState(false);
  const [flowsData, setFlowsData] = useState();
  const [flowsDataObject, setFlowsDataObj] = useState();
  const [flowSelected, setFlowSelected] = useState();

  useEffect(() => {
    getFlows();
    if (open === "edit") {
      const existing = data?.data?.flowSelected;
      const selectedName =
        typeof existing === "string"
          ? existing
          : existing && typeof existing === "object"
          ? existing.name || ""
          : "";
      setFlowSelected(selectedName);
      setActiveModal(true);
    } else if (open === "create") {
      setFlowSelected("");
      setActiveModal(true);
    }
  }, [open]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
  };

  const getFlows = async () => {
    return await api.get("/flowbuilder").then((res) => {
      setFlowsData(res.data.flows.map((flow) => flow.name));
      setFlowsDataObj(res.data.flows);
      return res.data.flows;
    });
  };

  const handleSaveContact = () => {
    const selected = flowsDataObject?.find((flow) => flow.name === flowSelected);
    const flowSelectedObj = selected
      ? { id: selected.id, name: selected.name }
      : { name: flowSelected || "" };
    if (open === "edit") {
      handleClose();
      onUpdate({
        ...data,
        data: { ...data.data, flowSelected: flowSelectedObj },
      });
    } else if (open === "create") {
      handleClose();
      onSave({
        flowSelected: flowSelectedObj,
      });
    }
  };

  return (
    <AerosDialog
      open={activeModal}
      onClose={handleClose}
      width={480}
      title={i18n.t(open === "edit" ? "aeros.flow.modals.switchFlow.editTitle" : "aeros.flow.modals.switchFlow.addTitle")}
      onSubmit={handleSaveContact}
      submitLabel={i18n.t(open === "edit" ? "aeros.flow.save" : "aeros.flow.add")}
    >
      <div>
        <label className={m.fieldLabel} htmlFor="flow-switch-select">
          {i18n.t("aeros.flow.modals.switchFlow.flow")}
        </label>
        {flowsDataObject && flowsDataObject.length > 0 && (
          <Autocomplete
            id="flow-switch-select"
            value={flowSelected || ""}
            options={flowsData || []}
            onChange={(event, newValue) => {
              setFlowSelected(newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                className={m.input}
                variant="outlined"
                placeholder={i18n.t("aeros.flow.modals.switchFlow.placeholder")}
              />
            )}
          />
        )}
        <div className={m.hint}>{i18n.t("aeros.flow.modals.switchFlow.hint")}</div>
      </div>
    </AerosDialog>
  );
};

export default FlowBuilderAddSwitchFlowModal;
